module.exports = __webpack_public_path__ + "static/title-graphic-c8badecc256986ebed8d77d440e36631.png";